import { useQuery } from '@tanstack/react-query'

import {
  fetchMyFeatureAccess,
  MY_FEATURE_ACCESS_QUERY_KEY,
  type FeatureAccessOutsiderView,
  type MyFeatureAccessMap,
} from '@/services/feature-access-api'

/**
 * Merkezi erişim haritası (#825): kullanıcının TÜM özellikler için sunucu kararı
 * tek istekte gelir; sayfalar `useFeatureAccess(anahtar)` ile okur. Karar sunucuda
 * verilir (arayüz yalnız gösterir); sunucu zaten kapıyı ayrıca zorlar.
 */
export function useAccessMap() {
  return useQuery<MyFeatureAccessMap>({
    queryKey: MY_FEATURE_ACCESS_QUERY_KEY,
    queryFn: fetchMyFeatureAccess,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}

/**
 * Tek özellik için erişim. Yükleniyorken `allowed: null` (karar yok); hata,
 * bilinmeyen anahtar ya da `allowed !== true` → `false` (fail-closed).
 */
export function useFeatureAccess(featureKey: string): {
  isPending: boolean
  allowed: boolean | null
  outsiderView: FeatureAccessOutsiderView
} {
  const query = useAccessMap()
  if (query.status === 'pending') {
    return { isPending: true, allowed: null, outsiderView: 'hidden' }
  }
  const entry = query.status === 'success' ? query.data[featureKey] : undefined
  return {
    isPending: false,
    allowed: entry?.allowed === true,
    outsiderView: entry?.outsider_view === 'coming_soon' ? 'coming_soon' : 'hidden',
  }
}
